<template>

  <b-form-group
    :label="label"
    :label-for="id"
    class="bold-label mb-4"
    :invalid-feedback="selectValue.invalidFeedback"
    :state="selectValue.state">
    <div v-if="info">{{info}}</div>
    <b-form-select
      :id="id"
      v-model="selectValue.value"
      :state="selectValue.state"
      :required="isRequired">
      <option v-for="option in options" :value="isEnum? option.value: option.id">
        {{ isEnum? $t(option.text): option.tostring }}
      </option>
    </b-form-select>
    <b-form-text>{{helpMessage}}</b-form-text>
  </b-form-group>

</template>

<script>
export default {
  name: 'SelectField',

  props: {
    selectValue: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: 'input'
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: null
    },
    helpMessage: {
      type: String,
      default: null
    },
    isEnum: {
      type: Boolean,
      default: false
    }
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/SelectField.vue